module.exports = __webpack_public_path__ + "img/arrows-left-right.37905fa9.svg";